import getPrototypeOf from "./getPrototypeOf";
export default function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/superPropBase.js
// module id = 885
// module chunks = 0